import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  rootSuccess: {
    flex: 0,
    flexDirection: 'row',
    backgroundColor: '#13223b',
    borderColor: '#7AB800', 
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
  },
  iconType: {
    paddingRight: 20,
  },
  typeMessage: {
    justifyContent: 'center',
    flex: 0.9,
  },
  closeMark: {
    alignItems: 'flex-end',
    flex: 0.1,
  },
});